var _rect, _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.202148,
    y: 0.173828,
    width: 61.2492,
    height: 39.2972,
    rx: 9,
    fill: "#143950"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8159 28.4484V12.089C40.8159 10.8036 39.5537 9.75195 38.0109 9.75195H18.3754C16.8326 9.75195 15.5703 10.8036 15.5703 12.089V28.4484C15.5703 29.7338 16.8326 30.7854 18.3754 30.7854H38.0109C39.5537 30.7854 40.8159 29.7338 40.8159 28.4484ZM23.2843 22.0215L26.7906 25.5388L31.6995 20.2687L38.0109 27.2799H18.3754L23.2843 22.0215Z",
    fill: "#8ED1DB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6682,
    cy: 25.2785,
    r: 6.41425,
    fill: "#143950"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6677,
    cy: 25.279,
    r: 4.98797,
    fill: "#8ED1DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6981 28.3335V26.2891H36.6648V24.5779H38.6981V22.5446H40.4093V24.5779H42.4426V26.2891H40.4093V28.3335H38.6981Z",
    fill: "#143950"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUploadIcon);
export default __webpack_public_path__ + "static/media/ImgUploadIcon.d718c08682ce7adf221de8077b482b18.svg";
export { ForwardRef as ReactComponent };